import { ClipboardList, FolderTree, Search, Sparkles, Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";

interface AgentQuickActionsProps {
  busy?: boolean;
  onCleanup: () => void;
  onFind: () => void;
  onOrganize: () => void;
  onSummarize: () => void;
}

export function AgentQuickActions({
  busy = false,
  onCleanup,
  onFind,
  onOrganize,
  onSummarize,
}: AgentQuickActionsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <Button disabled={busy} size="sm" type="button" variant="secondary" onClick={onOrganize}>
        <FolderTree className="h-4 w-4" />
        Organize
      </Button>
      <Button disabled={busy} size="sm" type="button" variant="secondary" onClick={onCleanup}>
        <Trash2 className="h-4 w-4" />
        Cleanup
      </Button>
      <Button disabled={busy} size="sm" type="button" variant="secondary" onClick={onFind}>
        <Search className="h-4 w-4" />
        Smart find
      </Button>
      <Button disabled={busy} size="sm" type="button" variant="secondary" onClick={onSummarize}>
        <ClipboardList className="h-4 w-4" />
        Summarize
      </Button>
      <Button disabled size="sm" type="button" variant="ghost">
        <Sparkles className="h-4 w-4" />
        More soon
      </Button>
    </div>
  );
}
